import React from 'react';
import styled, { css } from 'styled-components';

export default React.forwardRef(function({
  padding = 'none',
  paddingX = null,
  paddingY = null,
  boxShadow = 'none', // "standard" // "medium" | "small" | "large" | "outlineFocus"
  borderWidth = null,
  borderColor = null,
  borderRadius = 'none',
  ...props
}, forwardingReference) {
  return (
    <Element
      ref={forwardingReference}
      padding={padding}
      paddingX={paddingX}
      paddingY={paddingY}
      boxShadow={boxShadow}
      borderWidth={borderWidth}
      borderColor={borderColor}
      borderRadius={borderRadius}
      {...props}
    />
  );
});

const Element = styled.div`
  padding: ${props => props.theme.tokens.space[props.padding]}rem;
  
  ${props => props.paddingX !== null && css`
    padding-right: ${props => props.theme.tokens.space[props.paddingX]}rem;
    padding-left: ${props => props.theme.tokens.space[props.paddingX]}rem;
  `};
  
  ${props => props.paddingY !== null && css`
    padding-top: ${props => props.theme.tokens.space[props.paddingY]}rem;
    padding-bottom: ${props => props.theme.tokens.space[props.paddingY]}rem;
  `};

  box-shadow: ${props => props.theme.tokens.shadows[props.boxShadow]};
  
  border: ${props => props.theme.tokens.border.width[props.borderWidth]}rem solid ${props => props.theme.tokens.border.color[props.borderColor]};
  border-radius: ${props => props.theme.tokens.border.radius[props.borderRadius]}rem;
`;
